import React, { useEffect, useState, useRef  } from "react";
import api from "~/services/api";
import HandleFormData from "~/utils/HandleFormData";
import { Label, Input, Select, TextArea } from "~/componentes/CustomForm";
import ColoredFileInput from "~/componentes/CustomForm/FileInput/styles/ColoredFileInput";

import { store } from "~/store";
import { loadingToggle } from "~/store/modules/loadingModal/actions";
import { renderToString } from "react-dom/server";
import { jsPDF } from 'jspdf';

import SDTemplate from './Template/SDTemplate';
import NunitoSemiBold from '~/utils/Nunito-semiBold.js';

import { Container } from "./styles";
import { Materialize } from "~/styles/materializeGrid";
import ShowConfirmacao from "~/utils/ShowConfirmacao";
import PrioridadeListColor from "./PrioridadeListColor";
import AtividadesList from "./AtividadesList";
import StatusDataList from "./StatusDataList";
import CondPagList from "./CondPagList";

function CreateEditContent({ mountedData }) {
  const [abaAtiva, setAbaAtiva] = useState(0);
  const abas = [
    { titulo: "Solicitação" },
    { titulo: "Escopo" },
    { titulo: "Configuração" },
    { titulo: "Comercial" },
    { titulo: "Juridico" },
  ];
  
  const dispatch = store.dispatch;
  const [etapas, setEtapas] = useState([]);
  const [etapasFull, setEtapasFull] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(mountedData ? mountedData?.cliente : {});
  const [solicitantes, setSolicitantes] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [condicoesPagamento, setCondicoesPagamento] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [prioridade, setPrioridade] = useState(mountedData ? mountedData?.prioridade : {});
  const [idEtapa, setIdEtapa] = useState(mountedData ? mountedData?.idEtapa : 1);
  const [horaTotal, setHoraTotal] = useState(mountedData ? mountedData?.horaTotal : 0);
  const [valorHora, setValorHora] = useState(mountedData?.valorHora ? mountedData?.valorHora : 0);
  const [valorTotal, setValorTotal] = useState(mountedData?.valorTotal ? mountedData?.valorTotal : 0);
  const [valorBruto, setValorBruto] = useState(mountedData?.valorBruto ? mountedData?.valorBruto : 0);
  const [percentualDesconto, setPercentualDesconto] = useState(mountedData?.percentualDesconto ? mountedData?.percentualDesconto : 0);
  const [valorDesconto, setValorDesconto] = useState(mountedData?.valorDesconto ? mountedData?.valorDesconto : 0);
  const [tipoPagamento, setTipoPagamento] = useState(mountedData?.tipoPagamento ? mountedData?.tipoPagamento : "P");
  const [gerarProjeto, setGerarProjeto] = useState(false);
  const [ultimaEtapa, setUltimaEtapa] = useState(false);
  const [removeArquivos, setRemoveArquivos] = React.useState([]);
  const [statusDatas, setStatusDatas] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [dataInicioProjeto, setDataInicioProjeto] = useState(mountedData ? mountedData?.dataSolicitacao : new Date());
  const [file1, setFile1] = useState();
  const [file2, setFile2] = useState();
  const [file3, setFile3] = useState();
  const [file4, setFile4] = useState();
  const [ativo, setAtivo] = useState(
    !mountedData ? "true" : mountedData?.ativo ? "true" : "false",
  );
  const [geraPdf, setGeraPdf] = useState(false);
  const pdfRef = useRef(null);

  const handleDownload = async () => {
    dispatch(loadingToggle());

    let htmlElement = <SDTemplate data={mountedData} produtos={produtos} />;
    let elementAsString = renderToString(htmlElement);

    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: 'p'
    });
    doc.addFileToVFS('Nunito-semibold.ttf', NunitoSemiBold);
    doc.addFont('Nunito-semibold.ttf', 'Nunito', 'normal');
    doc.setFont('Nunito');

    doc.setFontSize(10);
    doc.html(elementAsString, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
        dispatch(loadingToggle());
      },
    });
  };

  useEffect(() => {
    if (mountedData) {
      api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { ativo: 1, tipo: "ORC" } }).then((r) => {
        setEtapas(r?.data);
        setIdEtapa(mountedData?.idEtapa);
      });
    } else {
      api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { ativo: 1, tipo: "ORC", posicao: 1 } }).then((r) => {
        setEtapas(r?.data);
        if (r?.data?.length > 0) {
          setIdEtapa(r?.data[0]?.id);
        }
      });
    }
    
    api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { ativo: 1, tipo: "ORC" } }).then((r) => {
      setEtapasFull(r?.data);
    });
    api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } }).then((r) => setClientes(r?.data));
    api.get("/signed/empresa/gestorprojeto/gerencia/coordenadores", { params: { ativo: 1 } }).then((r) => setCoordenadores(r?.data));
    api.get("/signed/empresa/gestorprojeto/gerencia/produtos", { params: { ativo: 1 } }).then((r) => setProdutos(r?.data));
    api.get("/signed/empresa/gestorprojeto/gerencia/prioridades", { params: { ativo: 1 } }).then((r) => setPrioridades(r?.data));
    api.get("/signed/empresa/gestorprojeto/gerencia/vendedores", { params: { ativo: 1 } }).then((r) => {
      setVendedores(r?.data);
    });
    
    setUltimaEtapa(mountedData?.etapa?.final == "S" ? true : false);
  }, []);

  useEffect(() => {
    if (cliente?.id) {
      cliente?.id && api.get("/signed/empresa/gestorprojeto/gerencia/clientesolicitantes", { params: { ativo: 1, idCliente: cliente?.id } }).then((r) => setSolicitantes(r?.data));
      cliente?.id && api.get("/signed/empresa/gestorprojeto/projetos", { params: { ativo: 1, idCliente: cliente?.id } }).then((r) => setProjetos(r?.data));
    } else {
      setSolicitantes([]);
      setProjetos([]);
    }
  }, [cliente]);

  useEffect(() => {
    if (geraPdf) {
      handleDownload();
      setGeraPdf(false);
    }
  }, [geraPdf]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = HandleFormData([file1, file2, file3, file4], {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === "true" ? true : false,
          valorHora,
          valorTotal,
          percentualDesconto,
          valorDesconto,
          valorBruto,
          gerarProjeto,
          recursos,
          idEtapaFluxo: idEtapa,
          etapas: statusDatas,
          tipoPagamento,
          horaTotal,
          prioridade,
          origem: "PRO",
          atividades,
          condicoesPagamento,
          removeArquivos,
        });

        let response;
        if (mountedData?.id)
          response = await api.put("/signed/empresa/gestorprojeto/fluxoorcamento", thisData);
        else
          response = await api.post("/signed/empresa/gestorprojeto/fluxoorcamento", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"
            } esse Orçamento, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"
          } esse Orçamento?`,
        successModal: `Orçamento ${mountedData?.id ? "atualizado" : "cadastrado"
          } com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          {abas.map((thisVal, a) => (
            <div className={abaAtiva == a ? "item-aba ativo" : "item-aba"} onClick={() => setAbaAtiva(a)}>
              <span></span>
              <p>{thisVal?.titulo}</p>
            </div>
          ))}
        </div>
        {
          <div>
            <div className={abaAtiva == 0 ? "item-modal ativo" : " item-modal"}>
              <div className="row no-margin">
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Título *" className="col s12 m8 l8">
                      <Input {...(mountedData ? { disabled:"true" } : {})} name="titulo" required="true" defaultValue={mountedData?.titulo} />
                    </Label>
                    <Label title="Data Solicitação *" className="col s12 m4 l4">
                      <Input 
                        type="date" 
                        disabled="true"
                        name="dataSolicitacao" 
                        required="true" 
                        defaultValue={mountedData?.dataSolicitacao} 
                        onBlur={(e) => {
                          const v = e.currentTarget.value || "";
                          setDataInicioProjeto(v);
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Cliente *" className="col s6 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: clientes, value: "id", label: "nomeFantasia" }}
                        name="idCliente"
                        disabled="true"
                        firstOption
                        defaultValue={mountedData?.idCliente}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "true";
                          const cliente = clientes?.find((e) => e?.id == parseInt(v))
                          setCliente(cliente || {});
                        }}
                      />
                    </Label>
                    <Label title="Solicitante Cliente *" className="col s6 m4 l4">
                      <Select
                        required="true"
                        isString
                        disabled="true"
                        list={{ list: solicitantes, value: "id", label: "nome" }}
                        name="idClienteSolicitante"
                        firstOption
                        defaultValue={mountedData?.idClienteSolicitante}
                      />
                    </Label>
                    <Label title="Líder Tec*" className="col s6 m4 l4">
                      <Select
                        required="true"
                        isString
                        disabled="true"
                        list={{ list: coordenadores, value: "id", label: "nome" }}
                        name="idCoordenadorTec"
                        firstOption
                        defaultValue={mountedData?.idCoordenadorTec}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Produto *" className="col s6 m4 l4">
                      <Select
                        required="true"
                        isString
                        disabled="true"
                        list={{ list: produtos, value: "id", label: "titulo" }}
                        name="idProduto"
                        firstOption
                        defaultValue={mountedData?.idProduto}
                      />
                    </Label>
                    <Label title="Hora Total" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="horaTotal"
                        disabled="true"
                        min="1"
                        value={horaTotal}
                      />
                    </Label>
                    <Label title="Ativo *" className="col s6 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: [{ id: "true", titulo: "Sim" }, { id: "false", titulo: "Não" }], value: "id", label: "titulo" }}
                        name="ativo"
                        defaultValue={mountedData?.ativo?.toString()}
                        onChange={(e) => {
                          const v = e.currentTarget.value || "true";
                          setAtivo(v);
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Vendedor *" className="col s6 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: vendedores, value: "id", label: "perfil.usuario.nome" }}
                        name="idVendedor"
                        firstOption
                        disabled="true"
                        defaultValue={mountedData?.idVendedor}
                      />
                    </Label>
                  </div>
                </div>
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Descrição da Solicitação" className="col s12 m12 l12">
                      <TextArea name="descricaoSolicitacao" disabled="true" className="fullText" defaultValue={mountedData?.descricaoSolicitacao} />
                    </Label>
                  </div>
                </div>
              </div>
              <div className="row no-margin">
                <Label title="Anexo 1" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo1"
                    defaultFile={mountedData?.anexo1}
                    formFile={setFile1}
                    disabled="true"
                    onDefaultFileRemove={(e) => e?.id && setRemoveArquivos((prev) => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 2" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo2"
                    defaultFile={mountedData?.anexo2}
                    formFile={setFile2}
                    disabled="true"
                    onDefaultFileRemove={(e) => e?.id && setRemoveArquivos((prev) => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 3" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo3"
                    defaultFile={mountedData?.anexo3}
                    formFile={setFile3}
                    disabled="true"
                    onDefaultFileRemove={(e) => e?.id && setRemoveArquivos((prev) => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 4" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo4"
                    defaultFile={mountedData?.anexo4}
                    formFile={setFile4}
                    disabled="true"
                    onDefaultFileRemove={(e) => e?.id && setRemoveArquivos((prev) => [...prev, e?.id])}
                  />
                </Label>
              </div>
            </div>
            <div className={abaAtiva == 1 ? "item-modal ativo" : "item-modal"}>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <AtividadesList setter={setAtividades} defaultData={mountedData?.atividades || []} setterSoma={setHoraTotal} />
                </div>
              </div>
            </div>
            <div className={abaAtiva == 2 ? "item-modal ativo" : "item-modal"}>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <StatusDataList setter={setStatusDatas} defaultData={mountedData?.etapas || []} etapasList={etapasFull} dataInicio={dataInicioProjeto}/>
                </div>
              </div>
            </div>
            <div className={abaAtiva == 3 ? "item-modal ativo" : " item-modal"}>
              <div className="row no-margin">
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Hora Total" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="horaTotal"
                        disabled="true"
                        min="1"
                        value={horaTotal}
                      />
                    </Label>
                    <Label title="Valor Hora" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="valorHora"
                        required="false"
                        value={valorHora}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setValorHora(v);
                          setValorBruto(v * horaTotal);
                          setValorTotal((v * horaTotal) - valorDesconto);
                        }}
                      />
                    </Label>
                    <Label title="Valor Bruto" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="valorBruto"
                        required="false"
                        value={valorBruto}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setValorBruto(v);
                          setValorHora((v / horaTotal).toFixed(2));
                          setValorTotal((v - valorDesconto).toFixed(2));
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="% Desconto" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="percentualDesconto"
                        required="false"
                        value={percentualDesconto}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setPercentualDesconto(v);
                          setValorDesconto(valorBruto * (v / 100));
                          setValorTotal((valorBruto - (valorBruto * (v / 100))).toFixed(2));
                        }}
                      />
                    </Label>
                    <Label title="Valor Desconto" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="valorDesconto"
                        required="false"
                        value={valorDesconto}
                        onChange={(e) => {
                          const v = e.currentTarget.value || 0;
                          setValorDesconto(v);
                          setPercentualDesconto(((v * 100) / valorBruto).toFixed(2));
                          setValorTotal((valorBruto - (valorBruto * (v / 100))).toFixed(2));
                        }}
                      />
                    </Label>
                    <Label title="Valor Total" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="valorTotal"
                        required="false"
                        value={valorTotal}
                        disabled="true"
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Dias Vencimento Orç. *" className="col s6 m4 l4">
                      <Input
                        type="number"
                        name="diasVencimento"
                        required="false"
                        value={mountedData?.diasVencimento}
                      />
                    </Label>
                    <Label title="Versão Orçamento *" className="col s6 m4 l4">
                      <Input
                        name="versao"
                        required="false"
                        value={mountedData?.versao}
                        maxlength="10"
                      />
                    </Label>
                  </div>
                </div>
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Forma Pagamento *" className="col s6 m8 l8">
                      <Select
                        required="true"
                        isString
                        list={{ list: [{id: "DP", titulo: "Depósito em conta corrente ou Pix"}], value: "id", label: "titulo" }}
                        name="formaPagamento"
                        defaultValue={mountedData?.formaPagamento}
                      />
                    </Label>
                    <Label title="Tipo Pagamento *" className="col s6 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: [{id: "P", titulo: "Parcela"}, {id: "E", titulo: "Entrega"}, {id: "A", titulo: "Apontamento"}, {id: "D", titulo: "Dias DDL"}], value: "id", label: "titulo" }}
                        name="tipoPagamento"
                        onChange={(e) => {
                          const v = e.currentTarget.value || "P";
                          setTipoPagamento(v);
                          setCondicoesPagamento([]);
                        }}
                        defaultValue={tipoPagamento}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <CondPagList 
                      setter={setCondicoesPagamento} 
                      defaultData={mountedData?.condicoesPagamento || []} 
                      tipo={tipoPagamento} 
                      valorTotal={valorTotal}
                      atividades={atividades}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={abaAtiva == 4 ? "item-modal ativo" : " item-modal"}>
              <div className="row no-margin">
                <div className="col s12 m12 l12 no-padding">
                  <div className="row no-margin">
                    <Label title="Condições Gerais" className="col s12 m12 l12">
                      <TextArea name="condicoesGerais" className="fullTextGeral" defaultValue={mountedData?.condicoesGerais} />
                    </Label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </Materialize>
      <div className="footer">
        <Label title="Etapa *" className="no-margin item-footer" row={true}>
          <Select
            required="true"
            {...{ ...(ultimaEtapa ? { disabled: "true" } : {}) }}
            isString
            list={{ list: etapas, value: 'id', label: 'titulo' }}
            name="idEtapa"
            defaultValue={idEtapa}
            onChange={e => {
              const v = e.currentTarget.value || 0;
              setIdEtapa(parseInt(v));

              const item = etapas.find((data) => data?.id === parseInt(v));
              setGerarProjeto(item?.final == "S" ? true : false);
            }}
          />
        </Label>
        <Label title="Prioridade *" className="no-margin item-footer" row={true}>
          <Select
            required="true"
            disabled="true"
            isString
            list={{ list: prioridades, value: 'id', label: 'titulo' }}
            name="idPrioridade"
            defaultValue={mountedData?.prioridade?.id}
            onChange={e => {
              const v = e.currentTarget.value || 0;
              setPrioridade({id: v});
            }}
          />
        </Label>
        {mountedData && (
          <div className="btn-imp" onClick={() => setGeraPdf(true)}>
            <p>Imprimir Orçamento</p>
          </div>
        )}
      </div>
    </Container>
  );
}

export default CreateEditContent;
